import React from 'react';
import styles from './StarRating.module.css';

interface StarRatingProps {
  stars: number;        // 0-3
  maxStars?: number;    // 默认 3
  animated?: boolean;   // 是否启用逐个点亮动画
  size?: 'small' | 'medium' | 'large';
  showCount?: boolean;  // 是否显示 "X/3" 文字
}

const StarRating: React.FC<StarRatingProps> = ({
  stars,
  maxStars = 3,
  animated = false,
  size = 'medium',
  showCount = false,
}) => {
  return (
    <span className={`${styles.container} ${styles[size]}`}>
      {Array.from({ length: maxStars }, (_, i) => (
        <span
          key={i}
          className={`${styles.star} ${i < stars ? styles.filled : styles.empty} ${
            animated ? styles.animated : ''
          }`}
          style={animated && i < stars ? { animationDelay: `${i * 0.3}s` } : undefined}
        >
          {i < stars ? '⭐' : '☆'}
        </span>
      ))}
      {showCount && (
        <span className={styles.count}>
          {stars}/{maxStars}
        </span>
      )}
    </span>
  );
};

export default StarRating;
